/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import type { PageLayoutField } from '@jira/platform__entry-points-page-layout-fields/src/index.tsx';
// eslint-disable-next-line jira/restricted/@atlassian+jira-entry-point
// eslint-disable-next-line jira/restricted/@atlassian+jira-entry-point
// eslint-disable-next-line jira/restricted/@atlassian+jira-entry-point
import type {
	AnyEntryPoint,
	ReferenceFromEntryPoint,
} from '@jira/platform__entry-point/src/common/types.tsx';
import { useRouteEntryPoint } from '@jira/platform__entry-points-plugin/src/services/use-entry-point/index.tsx';
import { useCurrentRoute } from '@jira/platform__utils-router/src/index.tsx';

export const usePageLayoutEntryPoint = <TEntryPoint extends AnyEntryPoint>(
	layoutField: PageLayoutField,
): ReferenceFromEntryPoint<TEntryPoint> => {
	const route = useCurrentRoute();
	const entryPointReference = useRouteEntryPoint({ route });

	// oxlint-disable-next-line typescript/consistent-type-assertions
	return entryPointReference?.entryPoints[layoutField] as ReferenceFromEntryPoint<TEntryPoint>;
};
